import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import Main from '../Main/Main';
import rootReducer from '../../store/reducers/rootReducer';

import './App.scss';
import '../../assets/styles/fonts.css';

import { setConfig } from '../../store/reducers/configReducer';
import {
  setDigitalMuseumCMS,
  setPoweredByPurposeCMS,
  setBuildingBrighterFuturesCMS,
  setVerizonByTheNumbersCMS,
  setCommunicationsChangeTheWorldCMS,
  setCredoCMS,
  setInnovationCMS,
  setGlobal,
  setFontsLoaded
} from '../../store/reducers/mainReducer';

// import { ccwCmsData } from '../../models/TempCMSData';

const numberOfLatestStories = 4;

const App = () => {
  const version = 'v0.9.91c';
  const store = createStore(rootReducer);

  FetchConfig(store);
  GetFonts(store);

  return (
    <div className={`App ${version}`}>
      <Provider store={store}>
        <Main version={version} />
      </Provider>
    </div>
  );
};


function FetchConfig(store) {
  fetch(randomizeUrl(process.env.PUBLIC_URL + '/config/config.json'), {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then(response => response.json())
    .then(configData => {
      if (configData) {
        store.dispatch(setConfig({ config: configData }));
        FetchCMS(
          randomizeUrl(configData.basePath + configData.apiPath.digitalMuseum),
          randomizeUrl(configData.basePath + configData.apiPath.poweredByPurpose),
          randomizeUrl(configData.basePath + configData.apiPath.buildingBrigtherFutures),
          randomizeUrl(configData.basePath + configData.apiPath.verizonByTheNumbers),
          randomizeUrl(configData.basePath + configData.apiPath.communicationsChangeTheWorld),
          randomizeUrl(configData.basePath + configData.apiPath.credo),
          randomizeUrl(configData.basePath + configData.apiPath.innovation),
          randomizeUrl(configData.basePath + configData.apiPath.global),
          store
        );
      } else {
        console.logWarning('Config is null!');
      }
    });
  }


function randomizeUrl(val){
  return val + "?r="+Math.random()*99999;
}

function FetchCMS(digitalURL,
  pbpURL, bbfURL,
  vbnURL,
  ccwURL, credoURL, innovationURL, global, store) {
  // Digital Museum Fetch
  fetch(digitalURL, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then(response => response.json())
    .then(cmsData => {
      if (cmsData[0]) {
        if (cmsData[0].Stories && cmsData[0].Stories.length) {
          let latestStories = [], archivedStories = [];
          cmsData[0].Stories.forEach((story, i) => {
            if (i < numberOfLatestStories) {
              latestStories.push(story);
            } else {
              archivedStories.push(story);
            }
          });
          cmsData[0].Stories = latestStories;
          cmsData[0].ArchivedStories = archivedStories;
          cmsData[0].AllStories = [...latestStories, ...archivedStories];
        }
        store.dispatch(setDigitalMuseumCMS({ data: cmsData[0] }));
      } else {
        console.log('CMS data is null!');
      }
    });

  // Powered By Purpose Fetch
  fetch(pbpURL, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
      .then(response => response.json())
      .then(cmsData => {
        if (cmsData[0]) {
          store.dispatch(setPoweredByPurposeCMS({ data: cmsData[0] }));
        } else {
          console.log('CMS data is null!');
        }
      });

  // Verizon By The Numbers Fetch
  fetch(vbnURL, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
      .then(response => response.json())
      .then(cmsData => {
        if (cmsData[0]) {
          store.dispatch(setVerizonByTheNumbersCMS({ data: cmsData[0] }));
        } else {
          console.log('CMS data is null!');
        }
      });

  // Communicatinos Change the World Fetch
  fetch(ccwURL, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
      .then(response => response.json())
      .then(cmsData => {
        if (cmsData[0]) {
          store.dispatch(setCommunicationsChangeTheWorldCMS({ data: cmsData[0] }));
        } else {
          console.log('CMS data is null!');
        }
      });

  // Communicatinos Change the World Fetch
  fetch(credoURL, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
      .then(response => response.json())
      .then(cmsData => {
        if (cmsData[0]) {
          store.dispatch(setCredoCMS({ data: cmsData[0] }));
        } else {
          console.log('CMS data is null!');
        }
      });

  // Innovation Rewind Fetch
  fetch(innovationURL, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
      .then(response => response.json())
      .then(cmsData => {
        if (cmsData[0]) {
          store.dispatch(setInnovationCMS({ data: cmsData[0] }));
        } else {
          console.log('CMS data is null!');
        }
      });


  fetch(global, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then(response => response.json())
    .then(cmsData => {
      if (cmsData[0]) {
        store.dispatch(setGlobal({ data: cmsData[0] }));
      } else {
        console.log('CMS data is null!');
      }
    });


  fetch(bbfURL, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then(response => response.json())
    .then(cmsData => {
      if (cmsData[0]) {
        store.dispatch(setBuildingBrighterFuturesCMS({ data: cmsData[0] }));
      } else {
        console.log('CMS data is null!');
      }
    });
}

async function GetFonts(store){
  const boldFont = await import(/* webpackPreload: true */ '../../assets/fonts/verizon/VerizonNHGDS-Bold.woff');
  const boldItalicFont = await import(/* webpackPreload: true */ '../../assets/fonts/verizon/VerizonNHGDS-BoldItalic.ttf');
  const ItalicsFont = await import(/* webpackPreload: true */ '../../assets/fonts/verizon/VerizonNHGDS-Italic.ttf');
  const RegularFont = await import(/* webpackPreload: true */ '../../assets/fonts/verizon/VerizonNHGDS-Regular.ttf');
  store.dispatch(setFontsLoaded());
}

export default App;
